export default {
  projects: [],
  currentProject: null,
  projectBrowserPopup: false,
  showWidgetGrid: true,
  projectQ: null,
  wikiProjectId: null,
  showProjectList: false,
  historyOpts: {
    "start_date": null,
    "end_date": null,
    "ops": ["INSERT", "UPDATE", "DELETE"],
    "tables": ["centrelines", 'wells'],
    "rec_budget": 10000,
    "excludeAnonym": true
  },
  selectedQa: null,
  dashboardEnabled: false,
  projectboardEnabled: false,
  otfComment: ''
}



// WEBPACK FOOTER //
// ./src/store/modules/project/state.js